import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { BaseComponent } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';
import { EventUI, IPinItTrackFrontendApplicationService, PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';
import { Observable } from 'rxjs';

@Component({
    selector: 'pin-it-track-web-app-inline-menu',
    templateUrl: './pin.it.track.web.app.menu.inline.component.html',
    styleUrls: ['./pin.it.track.web.app.menu.inline.component.scss'],
    animations: [
        trigger('menu', [
            state('hiddenAnimated', style({
                height: '0px',
                paddingBottom: '0px',
                overflow: 'hidden'
            })),
            state('visibleAnimated', style({
                height: '*',
                overflow: 'visible'
            })),
            state('visible', style({
                opacity: 1,
                'z-index': 100
            })),
            state('hidden', style({
                opacity: 0,
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('visible => hidden', animate('.1s linear')),
            transition('hidden => visible', [style({ transform: 'scaleY(0.8)' }), animate('.12s cubic-bezier(0, 0, 0.2, 1)')])
        ])
    ]

})
export class PinItTrackWebAppMenuInlineComponent extends BaseComponent {

    constructor(private readonly servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.applicationServiceExt = this.servicesAccessor.coreServicesAccessor.applicationService;
    }

    public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

    @Input()
    public key: any = 'inline-menu';

    @Input()
    public style: { [key: string]: any } | null = null;

    @Input()
    public styleClass: string;

    public active: boolean;

    public currentUser$: Observable<IDtoUser> = this.servicesAccessor.coreServicesAccessor.authenticationService.currentUser$;

    public async editUserAsync(): Promise<void> {
        /*this.sereventService.sendEvent('dialog', {
            type: 'user',
            data: this.entityStoreFacadesAccessor.user
        });*/
    }

    public async logoutAsync(): Promise<void> {
        this.servicesAccessor.eventService.sendEvent(EventUI.NavigateToLogout);
    }

    public onClick(event: any) {
        this.servicesAccessor.coreServicesAccessor.applicationService.onInlineMenuClick(event, this.key);
        event.preventDefault();
    }

    public get isTooltipDisabled() {
        return !(this.servicesAccessor.coreServicesAccessor.applicationService.isSidebarSlim && !this.servicesAccessor.coreServicesAccessor.applicationService.isMobile);
    }

    public get tabIndex() {
        return !this.servicesAccessor.coreServicesAccessor.applicationService.isInlineMenuActive ? '-1' : null;
    }

}
